<!-- <input type="date" #calendar> -->

<div #calendarContainer>
</div>